import { AdFleetMapAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { MapAdIcon } from '@moia-dev/pace-icons'

export const AdFleetMapAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AdFleetMapAreaRoutes.route}
      Icon={MapAdIcon}
    />
  )
}
